import each from 'lodash/each'
import { setURLSearchParam } from './url'

export const getData = (entry) => {
    let data = entry.getAttribute('data-map')
    return JSON.parse(data)
}

export const setParameters = (entry, data) => {
    each(Object.keys(data), (key, index) => {
        console.log(key, data[key], index)

        // If is the last
        if (index < 2) {
            setURLSearchParam(entry, key, data[key])
        } else {
            setURLSearchParam(entry, key, data[key], true)
        }
    })
}